document.addEventListener('DOMContentLoaded', () => {
  const backToTopBtn = document.querySelector('[data-page-top]');
  if (!backToTopBtn) return;

  // スクロール時の表示制御
  window.addEventListener('scroll', () => {
    backToTopBtn.classList.toggle('show', window.scrollY > 300);
  });

  // クリック時にトップへスムーズスクロール
  backToTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});